import React, { useEffect, useState } from "react";
import {
  Box,
  CssBaseline,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
import api from "../../api/axiosInstance"
import AppBarComponent from "../../components/layout/AppbarComponent";

// Complexity calculation based on type and attributes
const calculateComplexity = (func) => {
  const det = parseInt(func.det || 0, 10);
  const ret = parseInt(func.ret || 0, 10);
  const ftr = parseInt(func.ftr || 0, 10);

  switch (func.type) {
    case "EI":
      if (det <= 4 && ftr <= 1) return "Low";
      if (det <= 15 && ftr <= 2) return "Average";
      return "High";
    case "EO":
      if (det <= 5 && ftr <= 1) return "Low";
      if (det <= 15 && ftr <= 3) return "Average";
      return "High";
    case "EQ":
      if (det <= 5 && ftr <= 1) return "Low";
      if (det <= 15 && ftr <= 3) return "Average";
      return "High";
    case "ILF":
      if (ret <= 1 && det <= 19) return "Low";
      if (ret <= 5 && det <= 50) return "Average";
      return "High";
    case "EIF":
      if (ret <= 5 && det <= 19) return "Low";
      if (ret <= 5 && det <= 50) return "Average";
      return "High";
    default:
      return "";
  }
};

// Estimate man-hours based on complexity
const estimateManHours = (complexity) => {
  switch (complexity) {
    case "Low": return 8;
    case "Average": return 16;
    case "High": return 24;
    default: return 0;
  }
};

const EstimateResult = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const [functions, setFunctions] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch functions from API
  useEffect(() => {
    const fetchFunctions = async () => {
      try {
        const res = await api.get(`api/software/${id}/functions`);
        setFunctions(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchFunctions();
  }, [id, API_URL]);

  if (loading) return <Typography>กำลังโหลดข้อมูล...</Typography>;

  const totalManHours = functions.reduce((sum, func) => {
    const complexity = calculateComplexity(func);
    return sum + estimateManHours(complexity);
  }, 0);

  return (
    <>
      <CssBaseline />
      <AppBarComponent />
      <Box sx={{ p: 2, minHeight: "100vh", backgroundColor: "#E3F2FD" }}>
        <Paper sx={{ p: 3, borderRadius: 2.5, maxWidth: "95%", margin: "0 auto", backgroundColor: "#E8F5FE" }}>
          <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
            สรุปการประเมิน Function Point - ซอฟต์แวร์ ID: {id}
          </Typography>

          <TableContainer component={Paper} sx={{ mb: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Function Name</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>DET</TableCell>
                  <TableCell>RET</TableCell>
                  <TableCell>FTR</TableCell>
                  <TableCell>Complexity</TableCell>
                  <TableCell>Man-Hours</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {functions.map((func, index) => {
                  const complexity = calculateComplexity(func);
                  const manHours = estimateManHours(complexity);
                  return (
                    <TableRow key={index}>
                      <TableCell>{func.name}</TableCell>
                      <TableCell>{func.type}</TableCell>
                      <TableCell>{func.det}</TableCell>
                      <TableCell>{func.ret}</TableCell>
                      <TableCell>{func.ftr}</TableCell>
                      <TableCell>{complexity}</TableCell>
                      <TableCell>{manHours}</TableCell>
                    </TableRow>
                  );
                })}
                <TableRow>
                  <TableCell colSpan={6} align="right" sx={{ fontWeight: "bold" }}>
                    รวม Man-Hours
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>{totalManHours}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={() => navigate(`/software/estimate/${id}`)}>
              แก้ไขข้อมูล
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default EstimateResult;
